import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  accordionDetailsSpan: {
    color: "#465869",
    marginBottom: 12,
    font: "600 16px Manrope",
    paddingBottom: 3
  }
}));

export default styles;
